import { SVGProps } from 'react';

export const TrashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.825 2.335H9.39A1.396 1.396 0 008 1c-.745 0-1.36.595-1.39 1.335H4.175c-.445 0-.87.19-1.165.525-.295.34-.425.785-.365 1.225l.045.325a.5.5 0 00.495.435h9.63a.5.5 0 00.495-.435l.045-.325c.06-.44-.07-.885-.365-1.225a1.552 1.552 0 00-1.165-.525zM12.365 6.073h-8.73a.5.5 0 00-.495.565l1.025 7.027C4.27 14.425 4.93 15 5.7 15h4.6c.77 0 1.43-.575 1.535-1.335l1.025-7.027a.5.5 0 00-.495-.565z"
      fill="currentColor"
    />
  </svg>
);
